/** What's new tour stops in page order; `variants` swap the body by the target's data-tour-variant. */
export const TOUR_STEPS = [
    {
        id: "recap",
        title: "AI recap",
        body: "Where this PA stands and what to do next, in a few lines.",
    },
    {
        id: "attention",
        title: "Needs attention",
        body: "AI answers to check, all in one place. Press [J] and [K] to move between them and [Enter] to confirm.",
    },
    {
        id: "full-pa",
        title: "The full PA",
        body: "Every section is still here. Flagged questions show here too, and an edit in either place updates both.",
    },
    {
        id: "documents",
        title: "Documents",
        body: "They stay open beside the form. Search every page from the box at the top, or pop them out into a second window.",
        variants: {
            drawer: "Open them from here. Search every page from the box at the top, or pop them out into a second window.",
            hidden: "Hidden for now. Open them from here, then search every page from the box at the top.",
            window: "Open in a second window, and they follow this PA. Search them with the box at the top of that window.",
        },
    },
    {
        id: "activity",
        title: "Activity",
        body: "Notes and history now live at the bottom of the page. This button jumps straight there.",
    },
    {
        id: "view",
        title: "New look or classic",
        body: "Prefer the classic page? Switch here and every PA opens the way you left it. What's new replays this tour.",
    },
];
